import React from 'react';
import { FaDownload, FaFilter, FaExclamationCircle } from 'react-icons/fa';
import Layout from './Layout';
import { useNavigate } from 'react-router-dom';

const Reports = () => {
    const navigate = useNavigate();

  return (
    <Layout heading="Reports">
      <div className="container py-4">
        <div className="row g-4">
          {/* Download Employee Records */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <button 
              className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2 p-3"
              onClick={() => navigate('/employee-records')}>
              <FaDownload />
              <span>Download Employee Records</span>
            </button>
          </div>

          {/* Filter Employee Remarks */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <button
              className="btn btn-warning text-dark w-100 d-flex align-items-center justify-content-center gap-2 p-3"
              onClick={() => navigate('/employee-remark-filter')}>
              <FaFilter />
              <span>Filter Employee Remarks</span>
            </button>
          </div>

          {/* Filter Missing Documents */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <button 
              className="btn btn-danger w-100 d-flex align-items-center justify-content-center gap-2 p-3"
              onClick={() => navigate('/missing-docs')}>
              <FaExclamationCircle />
              <span>Missing Documents</span>
            </button>
          </div>
        </div>
      </div>
    </Layout>

  );
};

export default Reports;
